import React from 'react';
import { useTranslation } from 'react-i18next';
import Header from '../Common/Header';
import Footer from '../Common/Footer';
import Banner from '../Elements/Banner';

var bnrimg = require('../../images/banner/privacidad.jpg');

const asArray = (v) => (Array.isArray(v) ? v : []);

const PrivacyPolicy = () => {
    const { t } = useTranslation();
    const sections = asArray(t('pages.legal.politicaRedesSociales.sections', { returnObjects: true }));
    return (
        <>
            <Header />
            <div className="page-content">
                <Banner title={t('pages.legal.politicaRedesSociales.banner.title')} pagename={t('pages.legal.politicaRedesSociales.banner.pagename')} description={t('pages.legal.politicaRedesSociales.banner.description')} bgimage={bnrimg} />

                <div className="section-full p-t80 p-b50 mobile-page-padding">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-10 col-md-12">
                                <div className="service-single-block m-b30">
                                    <h3 className="m-b20">{t('pages.legal.politicaRedesSociales.heading')}</h3>
                                    <p>{t('pages.legal.politicaRedesSociales.intro')}</p>

                                    {sections.map((item, index) => (
                                        <React.Fragment key={index}>
                                            <h4>{item.heading}</h4>
                                            {asArray(item.body).map((para, pIndex) => (
                                                <p key={pIndex}>{para}</p>
                                            ))}
                                        </React.Fragment>
                                    ))}

                                    <p><strong>{t('pages.legal.politicaRedesSociales.establishedLabel')}</strong> {t('pages.legal.politicaRedesSociales.establishedValue')}</p>
                                    <p><strong>{t('pages.legal.politicaRedesSociales.lastRevisedLabel')}</strong> {t('pages.legal.politicaRedesSociales.lastRevisedValue')}</p>
                                    <p><strong>SoltArc Services</strong></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
};

export default PrivacyPolicy;
